import { Table, Avatar, Empty } from "antd";
import React from "react";
import type { ColumnsType } from "antd/es/table";
import { GroupsTwoTone, GroupsOutlined, WorkspacePremiumOutlined } from "@mui/icons-material";
import { IGroupsMinimal } from "../../domain/types";

interface IProps {
    isFetching: boolean;
    userGroupData: IGroupsMinimal[];
    handleGroupSelect: (group: IGroupsMinimal) => void;
    searchTerm?: string;
    currentPage: number;
    handlePageChange: (page: number) => void;
}

const GroupsTable: React.FC<IProps> = ({
    isFetching,
    userGroupData,
    handleGroupSelect,
    searchTerm,
    currentPage,
    handlePageChange,
}) => {
    const groupColumns: ColumnsType<IGroupsMinimal> = [
        {
            dataIndex: "icon",
            key: "icon",
            width: 40,
            render: (_, record) => {
                return record.groupType === "license" ? <WorkspacePremiumOutlined /> : <GroupsOutlined />;
            },
        },
        {
            dataIndex: "name",
            key: "name",
        },
        {
            dataIndex: "userCount",
            key: "userCount",
            width: 40,
            render: (_, record) => (
                <div className="user-count">
                    <Avatar
                        size="small"
                        className={record.groupType === "license" ? "group-icon license-icon" : "group-icon"}
                        icon={<>{record.userCount > 99 ? "99+" : record.userCount.toString()}</>}
                    />
                    {record.capacity > 0 && record.groupType === "license" && (
                        <>
                            &nbsp;/&nbsp;
                            <Avatar
                                size="small"
                                className={record.groupType === "license" ? "group-icon license-icon" : "group-icon"}
                                icon={<>{record.capacity.toString()}</>}
                            />
                        </>
                    )}
                </div>
            ),
        },
    ];

    const filteredUserGroupData = userGroupData.filter(
        (group) => searchTerm && group.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Table
            columns={groupColumns}
            loading={isFetching}
            locale={{
                emptyText: (
                    <Empty
                        className="ant-empty-custom-icon"
                        description="No groups found"
                        image={<GroupsTwoTone className="large-icon" />}
                    />
                ),
            }}
            dataSource={searchTerm ? filteredUserGroupData : userGroupData}
            showHeader={false}
            pagination={{
                position: ["bottomCenter"],
                current: currentPage,
                onChange: (page) => handlePageChange(page),
                showSizeChanger: false,
            }}
            rowClassName={(record) => (record.groupType === "license" ? "license-row" : "")}
            onRow={(record) => ({
                onClick: () => {
                    handleGroupSelect(record);
                },
            })}
        />
    );
};

export default GroupsTable;
